import { Card, CardBody, Col } from "reactstrap";
import { RidgeBorderTitle } from "../../../Constants/Constants";
import { DottedBorderSubData } from "../../../Data/UiKits/HelperClasses";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const RidgeBorder = () => {
  return (
    <Col xl="3">
      <Card>
        <CommonCardHeader title={RidgeBorderTitle} span={DottedBorderSubData} />
        <CardBody>
          <div className="helper-common-box helper-p-wrapper">
            {dynamicNumber(3).map((item, index) => (
              <div key={index} className={`border-common-box border-s-inset b-width-${item}`}>
                b-width-{item}
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RidgeBorder;
